export default __webpack_public_path__ + "media/84e5cdfff11dae27b28742082970608c2db2a789e50491371ba0c3d4fe334f01.svg";